import React, {Component} from 'react';
import OrderHistoryView from '../components/Customer/OrderHistoryView';
import {bindActionCreators} from 'redux';
import onClickOutside from 'react-onclickoutside';
import * as orderActions from '../actions/orderActions';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import * as restaurantActions from '../actions/restaurantActions';
import * as basketActions from '../actions/basketActions';
import {withRouter} from 'react-router-dom';
import {confirmAlert} from 'react-confirm-alert';
import {translate} from 'react-i18next';
import * as productActions from '../actions/productActions';
import moment from 'moment/moment';
import * as _ from 'lodash';
import {checkBasketIsEmpty} from "../helpers";
import {clickOutsideConfig} from '../helpers';
import classNames from 'classnames';


class ReorderLayout extends Component {
  constructor(props) {
    super(props);
    this.openOrders = this.openOrders.bind(this);
    this.reorderOrder = this.reorderOrder.bind(this);
    this.changeRestaurantAndLoadOrder = this.changeRestaurantAndLoadOrder.bind(this);
    this.loadOrderInCart = this.loadOrderInCart.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.state = {
      openOrders: false,
    };
  };

  openOrders() {
    const {openOrders} = this.state;
    const {profile} = this.props;
    if (profile.isEmpty()) {
      return;
    }
    if (!openOrders) {
      const params = {
        limit: 5,
        currentTime: moment().format('HH:mm')
      };
      this.props.getOrdersForReorder(params).then(() => {
        this.setState({
          openOrders: !openOrders,
        });
      }).catch(error => {
      });
    } else {
      this.setState({
        openOrders: !openOrders,
      });
    }
  }

  reorderOrder(data) {
    const {t, restaurant, basket} = this.props;
    if (restaurant.id === data.restaurant.id) {
      this.loadOrderInCart(data);
    } else {
      if (checkBasketIsEmpty(basket)) {
        return this.changeRestaurantAndLoadOrder(data);
      }
      confirmAlert({
        message: t('confirm_restaurant_change'),
        buttons: [
          {
            label: t('continue'),
            onClick: () => this.changeRestaurantAndLoadOrder(data),
          },
          {
            label: t('cancel'),
          },
        ],
      });
    }
  }

  loadOrderInCart(data) {
    data.detail.forEach(obj => {
      let result = {};
      const {product} = obj;
      if (product.type === 'pizza') {
        if (product.available) {
          result = {
            productId: product.id,
            quantity: obj.quantity,
            size: obj.size,
            crustID: obj.crust,
            sauceID: obj.sauce,
            extraIngredientsMinus: product.extraIngredientsMinus,
            extraIngredientsPlus: product.extraIngredientsPlus,
            type: 'pizza'
          };
        }
      } else if (product.type !== 'deals') {
        if (product.available) {
          result = {
            productId: product.id,
            quantity: obj.quantity,
            optionQuantity: product.optionQuantity,
            sauceID: product.sauceID,
            type: 'product'
          };
        }
      } else {
        if (product.available) {
          const options = [];
          _.forEach(obj.options, objOption => {
            const optionType = objOption.product.type === 'pizza' ? 'pizza' : 'product';
            const optionsData = {
              productId: objOption.product.id,
              quantity: objOption.quantity || 1,
              size: objOption.size,
              crustID: objOption.crust,
              sauceID: objOption.sauce,
              optionQuantity: objOption.optionQuantity || objOption.product.optionQuantity,
              type: optionType
            };
            options.push({
              id: objOption.composition,
              type: objOption.type,
              data: optionsData,
            });
          });
          result = {
            productId: product.id,
            quantity: obj.quantity,
            options: options,
            type: 'deals'
          };
        }
      }
      if (!_.isEmpty(result)) {
        this.props.addToBasket(result);
      }
    });
  }

  changeRestaurantAndLoadOrder(data) {
    this.props.selectedRestaurant(data.restaurant.id).then(() => {
      this.props.clearBasket();
      this.props.selectType('pizza');
      const restaurantForUrl = this.props.restaurants.toArray().find(obj => {
        return obj.id === data.restaurant.id
      });
      this.props.history.push(`/${restaurantForUrl.name_for_url}/products/pizza`);
      this.loadOrderInCart(data);
    });
  }

  handleClickOutside() {
    this.setState({
      openOrders: false,
    });
  };

  render() {
    const {reorderOrder} = this;
    const {openOrders} = this.state;
    const {orders, language} = this.props;
    return (
      <span
        className={
          classNames('page-header__reorder-logo', {
            'page-header__reorder-logo--hover': !this.props.profile.isEmpty(),
          })
        }
        onClick={this.openOrders}
      >
        {openOrders &&
        <OrderHistoryView
          data={orders.toJS().reorder}
          reorderOrder={reorderOrder}
          language={language}
        />
        }
      </span>
    );
  }
}

ReorderLayout.propTypes = {
  orders: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

function mapStateToProps(state) {
  return {
    orders: state.order,
    profile: state.user.get('profile'),
    restaurant: state.restaurants.item,
    restaurants: state.restaurants.list,
    basket: state.basket,
    language: state.language.defaultLanguage,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getOrdersForReorder: bindActionCreators(orderActions.getOrdersForReorder, dispatch),
    selectedRestaurant: bindActionCreators(restaurantActions.selectedRestaurant, dispatch),
    addToBasket: bindActionCreators(basketActions.addToBasket, dispatch),
    clearBasket: bindActionCreators(basketActions.clearBasket, dispatch),
    selectType: bindActionCreators(productActions.selectType, dispatch),
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    translate('translations')(onClickOutside(ReorderLayout, clickOutsideConfig))));



// WEBPACK FOOTER //
// ./src/containers/Reorder.js